// LIBRARIES
import styled, { css } from "styled-components";
import CancelIcon from "@mui/icons-material/Cancel";

// MISC
import { BOXSHADOW, COLORS, FONTS } from "constants/styleVariables";
import { CircularProgress } from "@mui/material";

export const NotificationContainer = styled.div`
  position: absolute;
  border-radius: 20px;
  right: 3.5%;
  top: 13%;
  max-height: 785px;
  width: 400px;
  background: ${COLORS.primaryWhite};
  display: flex;
  flex-direction: column;
  padding: 20px 20px 20px 20px;
  box-shadow: ${BOXSHADOW.containerBoxShadow};

  :after {
    content: "";
    position: absolute;
    top: 0;
    left: 63%;
    width: 0;
    height: 0;
    border: 20px solid transparent;
    border-bottom-color: ${COLORS.primaryWhite};
    border-top: 0;
    margin-left: -20px;
    margin-top: -20px;
  }
`;

export const CloseIconContainer = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
`;

export const CloseIcon = styled(CancelIcon)`
  && {
    color: ${COLORS.thirdGray};
    padding: 0;
    margin-bottom: 0;
    cursor: pointer;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
`;

export const Title = styled.text`
  font-size: 22px;
  color: ${COLORS.terraCotta};
  font-family: ${FONTS.newsharp};
  font-weight: bold;
`;

export const SubtitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  margin-bottom: 15px;
`;

export const Subtitle = styled.text`
  font-size: 16px;
  color: ${COLORS.rainbowIndigo};
  font-family: ${FONTS.montserrat};
  font-weight: 600;
`;

export const Bar = styled.div`
  padding-top: 1px;
  background-color: ${COLORS.thirdGray};
  margin: 10px 0;
`;

export const TextContainer = styled.div(
  ({ color }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
  `
);

export const TextIcon = styled.img`
  width: 32px;
  height: 32px;
  margin-right: 8px;
`;

export const Text = styled.div(
  ({ color }) => css`
    font-size: 13px;
    font-family: ${FONTS.montserrat};
    font-weight: 600;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    color: ${color ? color : COLORS.secondaryBlack};
  `
);

export const HistoryNotificationText = styled.div`
  display: flex;
  margin-top: 150px;
  font-size: 16px;
  color: ${COLORS.cornflowerBlue};
  font-family: ${FONTS.newsharp};
  font-weight: bold;
  align-items: center;
  justify-content: center;
  text-decoration: underline;
`;

export const NotificationContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 3px;
  }
  ::-webkit-scrollbar-track {
    background-color: ${COLORS.thirdGray};
    border-radius: 10px;
    margin-block: 9px;
  }
  ::-webkit-scrollbar-thumb {
    background-image: linear-gradient(
      180deg,
      ${COLORS.cornflowerBlue} 0%,
      ${COLORS.rainbowIndigo} 100%
    );
    border-radius: 10px;
  }
`;

export const LoadingSign = styled(CircularProgress)`
  && {
    justify-content: center;
    align-items: center;
    color: ${COLORS.rainbowIndigo};
    opacity: 1 !important;
  }
`;

export const LoadingContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
